import { DataGrid, MUIButton, MUIDialog, MUISelect, MUITextField } from '@abb/arcadia-ui-react';
import * as React from 'react';
import { IServiceInstance, IServiceOption, ServiceInstance } from '../../../models';

/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
export default class ServerWithServicesTable extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            componentServiceInstances: this.props.componentServiceInstances.map((componentCI: any, idx: number) => {
                return {
                    ...componentCI,
                    counter: idx + 1
                };
            }),
            isModalOpen: false,
            serviceInstanceToDelete: null
        };
    }
    render() {
        const headerData = [
            { id: 'Instance', label: 'Instance', numeric: false, actions: false, enableSort: false },
            { id: 'Service', label: 'Service', numeric: false, actions: false, enableSort: false },
            { id: 'AssetType', label: 'Asset Type', numeric: false, actions: false, enableSort: false },
            { id: 'AllocateAssets', label: 'Allocate Assets', numeric: false, actions: false, enableSort: false },
            { id: 'Manage', label: 'Manage', numeric: false, actions: false, enableSort: false }
        ];
        const rows = this.state.componentServiceInstances.map((row: any, idx: number) => ({
            id: String(row.id ?? idx),
            Instance: row.counter,
            Service: this.renderService(row),
            AssetType: this.renderAssetType(row),
            AllocateAssets: this.renderAllocateAssets(row, 'Number must be greater than zero and cannot exceed available asset count'),
            Manage: this.renderManageButtons(row)
        }));

        return (
            <div>
                <DataGrid name={'machine-' + this.props.name} enableCheckbox={false} size={40} rowsPerPage={rows.length || 1} headerData={headerData} rows={rows} />
                <MUIDialog
                    variant='warning'
                    open={this.state.isModalOpen}
                    heading='Confirmation'
                    content='Deleting an instance credits available asset count for the service. Please confirm.'
                    primaryButtonText='Confirm'
                    secondaryButtonText='Cancel'
                    onClickPrimaryButton={() => {
                        this.props.deleteRow(this.state.serviceInstanceToDelete);
                        this.setState({ isModalOpen: false, serviceInstanceToDelete: null });
                    }}
                    secondaryButtonConfig={{ onClick: () => this.setState({ isModalOpen: false, serviceInstanceToDelete: null }) }}
                    onClose={() => { this.closeModal(); }}
                />
            </div>
        );
    }

    renderService(serviceInstance: IServiceInstance) {
        if (serviceInstance.isBeingEdited) {
            const options = this.props.availableServicesList.map((service: any) => {
                return {
                    id: String(service.id),
                    name: service.productName
                };
            });
            const selected = serviceInstance.selectedServiceType ? [String(serviceInstance.selectedServiceType.id)] : [];
            return <MUISelect name={'service-' + serviceInstance.id} size={32} dropdownLOV={options} selectedItem={selected} onChange={(value: any) => { this.updateServiceValue(value, serviceInstance); }} />;
        }
        return serviceInstance.selectedServiceType ? serviceInstance.selectedServiceType.productName : '';
    }

    renderAssetType(serviceInstance: IServiceInstance) {
        if (serviceInstance.isBeingEdited) {
            return <MUITextField name='' size={32} value={serviceInstance.assetType} isDisabled={true} />;
        }
        return serviceInstance.assetType;
    }

    renderAllocateAssets(serviceInstance: IServiceInstance, errorMessage: string) {
        if (serviceInstance.isBeingEdited) {
            return <MUITextField name='AllocatedAssets' size={32}
                value={serviceInstance.allocatedAssets.value.toString()}
                errors={serviceInstance.allocatedAssets.valid ? undefined : { AllocatedAssets: { message: errorMessage } }}
                onChange={(value: string) => this.updateAllocatedAssetsValue(value, serviceInstance)}
            />;
        }
        return serviceInstance.allocatedAssets.value.toString();
    }

    renderManageButtons(serviceInstance: IServiceInstance) {
        if (serviceInstance.isBeingEdited) {
            return <div className="flex-start">
                <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_save' disabled={(serviceInstance.selectedServiceType?.productName) && serviceInstance.allocatedAssets.valid ? false : true} onClickButton={() => {
                    this.props.updateServerWithServices(serviceInstance);
                }} />
                <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_cancel-1' onClickButton={() => this.props.cancelEdit()} />
            </div>;
        }
        return <div className="flex-start">
            <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_edit' onClickButton={() => { this.props.editExistingRow(serviceInstance); }} />
            <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_delete' onClickButton={() => {
                this.setState({
                    isModalOpen: true,
                    serviceInstanceToDelete: serviceInstance
                });
            }} />
        </div>;
    }

    closeModal() {
        this.setState({
            isModalOpen: false,
            serviceInstanceToDelete: null
        });
    }

    updateAllocatedAssetsValue(value: any, serviceInstanceEdited: ServiceInstance) {
        this.setState((prevState: any) => ({
            componentServiceInstances: prevState.componentServiceInstances.map((serviceInstance: ServiceInstance) => {
                return { ...serviceInstance, allocatedAssets: serviceInstanceEdited.id === serviceInstance.id ? { value, valid: this.isValidAllocatedAssets(value, serviceInstanceEdited) } : serviceInstance.allocatedAssets };
            })
        }));
    }

    isValidAllocatedAssets(value: any, channelInstanceEdited: ServiceInstance) {
        const checkValues = this.props.checkValues(channelInstanceEdited, value);
        return !isNaN(value) && Number.parseInt(value, 10) > 0 && checkValues;
    }

    updateServiceValue(selectedIds: any, serviceInstanceEdited: ServiceInstance) {
        const first = Array.isArray(selectedIds) ? selectedIds[0] : selectedIds;
        const newId = Array.isArray(selectedIds) && typeof first === 'object' && first !== null ? first.id : first;
        const newSelectedServiceType = this.props.availableServicesList.filter((serviceOption: IServiceOption) => String(serviceOption.id) === String(newId))[0];
        this.setState((prevState: any) => ({
            componentServiceInstances: prevState.componentServiceInstances.map((serviceInstance: ServiceInstance) => {
                return {
                    ...serviceInstance,
                    selectedServiceType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType : serviceInstance.selectedServiceType,
                    assetType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType.assetType.assetTypeName : serviceInstance.assetType,
                    allocatedAssets: {
                        value: serviceInstance.allocatedAssets.value,
                        valid: this.isValidAllocatedAssets(serviceInstance.allocatedAssets.value, {
                            ...serviceInstance,
                            selectedServiceType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType : serviceInstance.selectedServiceType,
                            assetType: serviceInstanceEdited.id === serviceInstance.id ? newSelectedServiceType.assetType.assetTypeName : serviceInstance.assetType,
                        })
                    }
                };
            })
        }));
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            componentServiceInstances: nextProps.componentServiceInstances.map((componentCI: any, idx: number) => {
                return {
                    ...componentCI,
                    counter: idx + 1
                };
            })
        });
    }
}
